const publications = [
    {
        year: 2026,
        title: "MoPLEx: Estimating Plackett-Luce Mixture Models for Multi-Objective Alignment",
        link: "https://arxiv.org/abs/2608.25200",
        authors: "Dongyue Li, Ziniu Zhang, Lu Wang, and Hongyang R. Zhang",
        publishingSite: "EMNLP",
        date: "2026",
        topic: "Language models",
    },
    {
        year: 2026,
        title: "Long-Context Demonstration Selection Using State Space Models",
        link: "",
        authors: "Ziniu Zhang, Zhenshuo Zhang, Ruoxuan Xiong, Gene Cooperman, and Hongyang R. Zhang",
        publishingSite: "Findings of EMNLP",
        date: "2026",
        topic: "Language models",
    },
    {
        year: 2026,
        title: "WinQ: Accelerating Quantization-Aware Training of Language Models Around Saddle Points",
        link: "https://arxiv.org/abs/2605.17471",
        authors: "Dongyue Li, Zechun Liu, Kai Yi, Zhenshuo Zhang, Changsheng Zhao, Raghuraman Krishnamoorthi, Harshit Khaitan, Hongyang R. Zhang, and Steven Li",
        publishingSite: "ICML",
        date: "2026",
        topic: "Neural net Hessian",
    },
    {
        year: 2026,
        title: "Efficient Estimation of Kernel Surrogate Models for Task Attribution",
        link: "https://arxiv.org/abs/2602.03783",
        authors: "Zhenshuo Zhang, Minxuan Duan, and Hongyang R. Zhang",
        publishingSite: "ICLR",
        date: "2026",
        topic: "Multitask learning",
    },
    {
        year: 2026,
        title: "One-Sided Matrix Completion from Ultra-Sparse Samples",
        link: "https://arxiv.org/abs/2601.12213",
        authors: "Hongyang R. Zhang, Zhenshuo Zhang, Huy L. Nguyen, Guanghui Lan",
        publishingSite: "TMLR",
        date: "2026",
        topic: "Matrix recovery",
    },
    {
        year: 2026,
        title: "Efficiently Learning Branching Networks for Multitask Algorithmic Reasoning",
        link: "https://arxiv.org/abs/2512.01113",
        authors: "Dongyue Li, Zhenshuo Zhang, Minxuan Duan, Edgar Dobriban, Hongyang R. Zhang",
        publishingSite: "KDD",
        date: "2026",
        topic: "Large-scale networks",
    },
    {
        year: 2026,
        title: "Learning Multimodal Embeddings for Traffic Accident Prediction and Causal Estimation",
        link: "https://arxiv.org/abs/2512.02920",
        authors: "Ziniu Zhang, Minxuan Duan, Haris N. Koutsopoulos, Hongyang R. Zhang",
        publishingSite: "KDD",
        date: "2026",
        topic: "Large-scale networks",
    },
    {
        year: 2026,
        title: "Scalable Multi-Objective and Meta Reinforcement Learning via Gradient Estimation",
        link: "https://arxiv.org/abs/2511.12779",
        authors: "Zhenshuo Zhang, Minxuan Duan, Youran Ye, Hongyang R. Zhang",
        publishingSite: "AAAI",
        date: "2026",
        topic: "Multitask learning",
    },
    {
        year: 2025,
        title: "Linear-Time Demonstration Selection for In-Context Learning via Gradient Estimation",
        link: "https://arxiv.org/abs/2508.19999",
        authors: "Ziniu Zhang, Zhenshuo Zhang, Dongyue Li, Lu Wang, Jennifer Dy, Hongyang R. Zhang",
        publishingSite: "EMNLP",
        date: "2025",
        topic: "Language models",
    },
    {
        year: 2025,
        title: "Precise High-Dimensional Asymptotics for Quantifying Heterogeneous Transfers",
        link: "https://arxiv.org/abs/2010.11750",
        authors: "Fan Yang, Hongyang R. Zhang, Sen Wu, Christopher Ré, Weijie Su",
        publishingSite: "Journal of Machine Learning Research",
        date: "2025",
        topic: "Multitask learning",
    },
    {
        year: 2025,
        title: "Efficient Ensemble for Fine-tuning Language Models on Multiple Datasets",
        link: "https://arxiv.org/abs/2505.21930",
        authors: "Dongyue Li, Ziniu Zhang, Lu Wang, and Hongyang R. Zhang",
        publishingSite: "ACL",
        date: "2025",
        topic: "Language models",
    },
    {
        year: 2024,
        title: "Noise Stability Optimization for Finding Flat Minima: A Hessian-based Regularization Approach",
        link: "http://arxiv.org/abs/2306.08553",
        authors: "Hongyang R. Zhang, Dongyue Li, and Haotian Ju",
        publishingSite: "TMLR",
        date: "2024",
        topic: "Neural net Hessian",
    },
    {
        year: 2024,
        title: "Scalable Fine-Tuning from Multiple Data Sources: A First-Order Approximation Approach",
        link: "https://arxiv.org/abs/2409.19458",
        authors: "Dongyue Li, Ziniu Zhang, Lu Wang, and Hongyang R. Zhang",
        publishingSite: "Findings of EMNLP",
        date: "2024",
        topic: "Language models",
    },
    {
	year: 2024,
	title: "Scalable Multitask Learning Using Gradient-based Estimation of Task Affinity",
	link: "https://dl.acm.org/doi/abs/10.1145/3637528.3671835",
	authors: "Dongyue Li, Aneesh Sharma, and Hongyang R. Zhang",
	publishingSite: "KDD",
	date: "2024",
	topic: "Multitask learning",
    },
    {
        year: 2024,
        title: "Learning Tree-Structured Composition of Data Augmentation",
        link: "http://arxiv.org/abs/2408.14381",
        authors: "Dongyue Li, Kailai Chen, Predrag Radivojac, and Hongyang R. Zhang",
        publishingSite: "Transactions on Machine Learning Research",
        date: "2024",
        topic: "Robustness and data augmentation",
    },
    {
        year: 2023,
        title: "Graph Neural Networks for Road Safety Modeling: Datasets and Evaluations for Accident Analysis",
        link: "https://arxiv.org/abs/2311.00164",
        authors: "Abhinav Nippani, Dongyue Li, Haotian Ju, Haris N. Koutsopoulos, and Hongyang R. Zhang",
        publishingSite: "NeurIPS, Datasets and Benchmarks Track",
        date: "2023",
        topic: "Large-scale networks",
    },
//    {
//        year: 2023,
//        title: "Noise Stability Optimization for Flat Minima with Tight Rates",
//        link: "https://arxiv.org/abs/2306.08553",
//        authors: "Haotian Ju, Dongyue Li, Hongyang R. Zhang",
//        publishingSite: "NeurIPS Workshop on Optimization",
//        date: "2023",
//        topic: "Algorithms, Learning Theory, Generalization Bounds",
//    },
    {
        year: 2023,
        title: "Improved Group Robustness via Classifier Retraining on Independent Splits",
        link: "https://arxiv.org/abs/2204.09583",
        authors: "Thien Hang Nguyen, Hongyang R. Zhang, and Huy L. Nguyen",
        publishingSite: "Transactions on Machine Learning Research",
        date: "2023",
        topic: "Robustness and data augmentation",
    },
    {
        year: 2023,
        title: "Boosting Multitask Learning on Graphs through Higher-Order Task Affinities",
        link: "https://arxiv.org/abs/2306.14009",
        authors: "Dongyue Li, Haotian Ju, Aneesh Sharma, and Hongyang R. Zhang",
        publishingSite: "KDD",
        date: "2023",
        topic: "Multitask learning",
    },
    {
        year: 2023,
        title: "Identification of Negative Transfers in Multitask Learning Using Surrogate Models",
        link: "https://arxiv.org/abs/2303.14582",
        authors: "Dongyue Li, Huy N. Nguyen, and Hongyang R. Zhang",
        publishingSite: "Transactions on Machine Learning Research (Featured Certification)",
        date: "2023",
        topic: "Multitask learning",
    },
    {
        year: 2023,
        title: "Generalization in Graph Neural Networks: Improved PAC-Bayesian Bounds on Graph Diffusion",
        link: "http://arxiv.org/abs/2302.04451",
        authors: "Haotian Ju, Dongyue Li, Aneesh Sharma, and Hongyang R. Zhang",
        publishingSite: "AISTATS",
        date: "2023",
        topic: "Neural net Hessian",
    },
    {
        year: 2023,
        title: "Optimal Intervention on Weighted Networks via Edge Centrality",
        link: "http://arxiv.org/abs/2303.09086",
        authors: "Dongyue Li, Tina Eliassi-Rad, and Hongyang R. Zhang",
        publishingSite: "SDM",
        date: "2023",
        topic: "Large-scale networks",
    },
//    {
//        year: 2022,
//        title: "Task Modeling: Approximating Multitask Predictions for Cross-task Transfer",
//        link: "https://arxiv.org/abs/2303.14582",
//        authors: "Dongyue Li, Huy L. Nguyen Hongyang R. Zhang",
//        publishingSite: "NeurIPS Workshop on Distribution Shifts",
//        date: "2022",
//        topic: "Multitask Learning",
//    },
    {
        year: 2022,
        title: "Robust Fine-Tuning of Deep Neural Networks with Hessian-based Generalization Guarantees",
        link: "https://arxiv.org/abs/2206.02659",
        authors: "Haotian Ju, Dongyue Li, and Hongyang R. Zhang",
        publishingSite: "ICML",
        date: "2022",
        topic: "Neural net Hessian",
    },
    {
        year: 2022,
        title: "Correct-N-Contrast: A Contrastive Approach for Improving Robustness to Spurious Correlations",
        link: "http://arxiv.org/abs/2203.01517",
        authors: "Michael Zhang, Nimit Sohoni, Hongyang R. Zhang, Chelsea Finn, and Christopher Ré",
        publishingSite: "ICML",
        date: "2022",
        topic: "Robustness and data augmentation",
    },
    {
        year: 2022,
        title: "Incentive Ratio: A Game Theoretical Analysis of Market Equilibria",
        link: "https://www.sciencedirect.com/science/article/pii/S0890540122000177",
        authors: "Ning Chen, Xiaotie Deng, Bo Tang, Hongyang R. Zhang, and Jie Zhang",
        publishingSite: "Information and Computation",
        date: "2022",
        topic: "Incentives and cooperative games",
    },
    {
        year: 2021,
        title: "Improved Regularization and Robustness for Fine-tuning in Neural Networks",
        link: "https://arxiv.org/abs/2111.04578",
        authors: "Dongyue Li and Hongyang R. Zhang",
        publishingSite: "NeurIPS",
        date: "2021",
        topic: "Robustness and data augmentation",
    },
    {
        year: 2021,
        title: "Observational Supervision for Medical Image Classification using Gaze Data",
        link: "https://link.springer.com/chapter/10.1007/978-3-030-87196-3_56",
        authors: "Khaled Saab, Sarah M. Hooper, Nimit S. Sohoni, Jupinder Parmar, Brian Pogatchnik, Sen Wu, Jared A. Dunnmon, Hongyang R. Zhang, Daniel Rubin, and Christopher Ré",
        publishingSite: "MICCAI",
        date: "2021",
        topic: "Robustness and data augmentation",
    },
    {
        year: 2020,
        title: "Learning Over-Parametrized Two-Layer ReLU Neural Networks beyond NTK",
        link: "https://arxiv.org/abs/2007.04596",
        authors: "Yuanzhi Li, Tengyu Ma, and Hongyang R. Zhang",
        publishingSite: "COLT",
        date: "2020",
        topic: "Matrix recovery",
    },
    {
        year: 2020,
        title: "On the Generalization Effects of Linear Transformations in Data Augmentation",
        link: "https://arxiv.org/abs/2005.00695",
        authors: "Sen Wu, Hongyang R. Zhang, Gregory Valiant, and Christopher Ré",
        publishingSite: "ICML",
        date: "2020",
        topic: "Robustness and data augmentation",
    },
    {
        year: 2020,
        title: "Understanding and Improving Information Transfer in Multi-Task Learning",
        link: "https://arxiv.org/abs/2005.00944",
        authors: "Sen Wu, Hongyang R. Zhang, and Christopher Ré",
        publishingSite: "ICLR",
        date: "2020",
        topic: "Multitask learning",
    },
];

export default publications;
